// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SaveButton-saveBtn-UsGLc {
	line-height: 43px;
}

span {
	text-decoration: none;
}

span:hover, span:active, span:focus, span:visited {
	text-decoration: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/List/SaveButton.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,gCAAgC;AACjC","sourcesContent":[".saveBtn {\n\tline-height: 43px;\n}\n\nspan {\n\ttext-decoration: none;\n}\n\nspan:hover, span:active, span:focus, span:visited {\n\ttext-decoration: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"saveBtn": `SaveButton-saveBtn-UsGLc`
};
module.exports = ___CSS_LOADER_EXPORT___;
